module.exports = __webpack_public_path__ + "static/How-Do-You-Prevent-Tension-Headaches-Before-They-Start-c0da0024c7acb4afc769f0273c48e6db.webp";